import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Layout from "../../components/Layout.js";

const GstnaturemasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchGridData = async () => {
    try {
      const response = await apiFetch(
        "/api/Gst/grid"
      );
      const data = await response.json();
      setGridData(data || []);
      setFilteredData(data || []);
    } catch (err) {
      console.error("❌ Error fetching Grid data:", err);
      alert("Unable to fetch data from backend.");
    }
  };

  useEffect(() => {
    fetchGridData();
  }, []);

  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };
  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };
  const headerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
    gap: "10px",
  };
  const leftHeaderStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: "250px",
  };
  const titleStyle = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    flexShrink: 0,
  };
  const addButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#3a28a0ff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const searchInputStyle = {
    flex: "1",
    minWidth: "700px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };
  const searchButtonStyle = {
    padding: "8px 12px",
    backgroundColor: "#2196F3",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const selectStyle = {
    padding: "8px 10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    whiteSpace: "nowrap",
  };
  const tableWrapperStyle = { overflowX: "auto" };
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "400px",
  };
  const thStyle = {
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#8B1E3F",
    color: "#fff",
    border: "1px solid #ddd",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
  };
  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    wordWrap: "break-word",
    fontSize: "0.85rem",
  };
  const actionButtonStyle = (bgColor) => ({
    padding: "6px 10px",
    marginRight: "5px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    minWidth: "60px",
    fontSize: "0.8rem",
  });
  const paginationStyle = {
    marginTop: "12px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.9rem",
  };
  const pageBtnStyle = {
    padding: "6px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#f9f9f9",
    fontSize: "0.85rem",
  };

  return (
    <Layout>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <div style={titleStyle}>GST Nature Master Grid</div>
          </div>
        </div>

        <div style={tableWrapperStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                {/* <th style={thStyle}>unqid</th> */} {/* Removed */}
                <th style={thStyle}>GSTNATURE</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>REFBK</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((row) => (
                  <tr key={row.sp_322}>
                    {/* <td style={tdStyle}>{row.sp_322}</td> */}{" "}
                    {/* Removed */}
                    <td style={tdStyle}>{row.sp_327}</td>
                    <td style={tdStyle}>{row.sp_328}</td>
                    <td style={tdStyle}>{row.sp_329}</td>
                    <td style={tdStyle}></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={tdStyle}>
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default GstnaturemasterGrid;
